import { apiFetch } from '@/lib/api';
import type { Category } from '@domain/types';

export type CategoryInput = {
  name: string;
  icon: string;
  color: string;
};

export class DuplicateCategoryError extends Error {
  constructor(public name: string) {
    super(`A category called "${name}" already exists.`);
    this.name = 'DuplicateCategoryError';
  }
}

export async function listCategories(): Promise<Category[]> {
  return apiFetch<Category[]>('/categories');
}

export async function createCategory(input: CategoryInput): Promise<Category> {
  try {
    return await apiFetch<Category>('/categories', {
      method: 'POST',
      body: JSON.stringify(input),
    });
  } catch (error) {
    if ((error as Error).message.includes('already exists')) {
      throw new DuplicateCategoryError(input.name);
    }
    throw error;
  }
}

export async function updateCategory(id: string, patch: Partial<CategoryInput>): Promise<void> {
  try {
    await apiFetch<void>(`/categories/${id}`, {
      method: 'PUT',
      body: JSON.stringify(patch),
    });
  } catch (error) {
    if ((error as Error).message.includes('already exists') && patch.name) {
      throw new DuplicateCategoryError(patch.name);
    }
    throw error;
  }
}

export async function deleteCategory(id: string): Promise<void> {
  await apiFetch<void>(`/categories/${id}`, {
    method: 'DELETE',
  });
}

export async function getCategoryUsage(id: string): Promise<number> {
  return apiFetch<number>(`/categories/${id}/usage`);
}
